var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "10px" } },
        [
          _vm.operationType !== "view"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onConfirmSort },
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              )
            : _vm._e(),
          _c("el-button", { on: { click: _vm.onCancel } }, [
            _vm._v(_vm._s(_vm.$t("common.cancel"))),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          key: _vm.refreshKey,
          ref: "sortableTable",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "", "row-key": "id" },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", prop: "sortIndex", width: "80" },
          }),
          _vm.operationType !== "view"
            ? _c("el-table-column", {
                attrs: { label: "拖拽排序", width: "80", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("i", {
                            staticClass:
                              "fas fa-grip-vertical drag-handle el-icon-rank",
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  320035748
                ),
              })
            : _vm._e(),
          _c("el-table-column", { attrs: { prop: "code", label: "参数编码" } }),
          _c("el-table-column", { attrs: { prop: "name", label: "参数名称" } }),
          _vm.operationType !== "view"
            ? _c("el-table-column", {
                attrs: { label: "操作", width: "180", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-top",
                                size: "mini",
                                disabled: scope.$index === 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moveUp(scope.$index)
                                },
                              },
                            },
                            [_vm._v("升序")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-bottom",
                                size: "mini",
                                disabled:
                                  scope.$index === _vm.tableData.length - 1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moveDown(scope.$index)
                                },
                              },
                            },
                            [_vm._v("降序")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  300675645
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }